module.exports = __webpack_public_path__ + "static/media/PowerPolitics.7c4445c0.png";